import React, { useEffect, useState, useRef } from "react";
import SendIcon from "../../components/Icons/solid/SendIcon";
import useTreatments from "../../store/treatments/treatmentsContext";
import useApp from "../../store/app/appContext";
import { ChatNotification, ReceiverMessageCard, SenderMessageCard } from '../../components/Cards/MessageCard';
import MoonLoader from 'react-spinners/MoonLoader'
import { COLORS } from "../../config";
import io from "socket.io-client";
import { SERVER_BASE_URL } from '../../config';

function TreatmentMessages({ treatmentInfo }) {

  const { getConversationMessages, sendMessage, 
    getTreatmentConversations } = useTreatments();
  
  const [messageText, setMessageText] = useState("");

  const socketClientRef = useRef()
  
  const {
    appState: { user, userAccount },
  } = useApp();
 
  const [activeConversationMessages, setActiveConversationMessages] = useState([]);

  const [treatmentConversations, setTreatmentConversations] = useState([]);
  const [activeConversation, setActiveConversation] = useState({
    type: null,
    isLoading: true,
    id: null,   
  });

  const chatBox = document.getElementById('chatBox');

  const fetchConversations = async (treatmentId) => {
    await getTreatmentConversations(treatmentId).then(res => {
      const conversations = res
      if (conversations) {
        setTreatmentConversations(conversations);
        setActiveConversation({
          type: conversations[0].conversation_type,
          isLoading: true,
          id: conversations[0]._id,
        })
      }
    })
  };
  
  const addSocketMessage = (data) => {
    const newMessageConversationId = data?.conversation_id._id
      if((activeConversation?.id === newMessageConversationId)) {
        setActiveConversationMessages(prevMessages => [...prevMessages, data])
        scrollToBottom(chatBox);
      }
  }
  

  useEffect(() => {
    fetchConversations(treatmentInfo._id);
    
  }, []);

  useEffect(() => {    
    const socket = io(SERVER_BASE_URL);
    socket.on("connect", () => {
      console.log('connected')
    })
    socket.on("disconnect", () => {
      console.log('disconnected')
    });
    socket.on("receive-message", addSocketMessage)
    socketClientRef.current = socket
    return () => {
      socket.removeAllListeners()
    }
    
  }, []);

  useEffect(() => {
    const conversationToFetch = treatmentConversations.find(c => c.conversation_type === activeConversation.type);
    if (conversationToFetch?._id) getConversationMessages(conversationToFetch._id).then(res => {
      const retrievedMessages = res.data?.data;
      if (retrievedMessages) {
        setActiveConversationMessages(retrievedMessages)
        setActiveConversation(prevState => ({ 
          ...prevState,
          isLoading: false,
          id: conversationToFetch._id
        }))
        scrollToBottom(chatBox);
      }
    })
  }, [activeConversation.type])

  useEffect(() => {
    socketClientRef.current.removeAllListeners('receive-message');
    socketClientRef.current.on("receive-message", addSocketMessage)
  }, [activeConversation.id])

  const scrollToBottom = (node) => {
    node.scrollTop = node.scrollHeight;
  }

  const handleMessage = () => {
    if(messageText  && messageText.trim()){
      sendMessage({ messageText, conversationId: activeConversation.id }).then(res => {
        socketClientRef.current.emit("new-message", res);
        setActiveConversationMessages(prevMessages => [...prevMessages, res])
        scrollToBottom(chatBox);
      });
      setMessageText("");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (event.shiftKey) {
        setMessageText(messageText + '\n');
        return event.stopPropagation();
      }
      else return handleMessage();
    }       
  }

  const isCurrentUser = (userId) => {
    if (userId === user._id) return true;
    return false;
  }

  return (
    <>
      <div className="bg-white rounded shadow py-7 px-10 h-auto block">
        <h1 className=" text-2xl text-secondary">Chat Room</h1>
        {userAccount.isPartnerOrAdmin && 
          <div className='w-full flex mt-4'>
            <div 
              className={`flex cursor-pointer justify-around w-1/2 font-semibold text-gray-400 border-b-2 border-gray-200 ${activeConversation.type === 'patient' && 'text-primary font-semibold border-b-2 border-primary'}`} 
              onClick={() => setActiveConversation(() => ({ type: 'patient', isLoading: true, id: null })) }
            >
                <span>Patient chat</span>
            </div>
            <div 
              className={`flex cursor-pointer justify-around w-1/2 font-semibold text-gray-400 border-b-2 border-gray-200 ${activeConversation.type === 'specialist' && 'text-primary font-semibold border-b-2 border-primary'}`} 
              onClick={() => setActiveConversation(() => ({ type: 'specialist', isLoading: true, id: null })) }
            >
                <span>Specialist chat</span>
            </div>
          </div>
        }
        <div id="chatBox" className='flex flex-col mt-4 overflow-y-auto' style={{ height: "400px" }}>
          {activeConversation.isLoading ?
            <div className='w-full flex justify-around mt-32'>
              <MoonLoader color={COLORS.colorPrimary}/>
            </div>
            :
            <div className="space-y-4 h-full pr-4">
              {activeConversationMessages.map((message)=> {
                if (message.notification) return <ChatNotification key={message._id} notification={message} />
                if (isCurrentUser(message.user_id._id)) return <SenderMessageCard key={message._id} message={message}/>
                return <ReceiverMessageCard key={message._id} message={message}/>
              })}
            </div>
          }
        </div>
         <hr className="mt-4 w-full" />
        <div>
          <div className="flex flex-wrap w-full bg-white items-center rounded">
            <textarea
              id="chatTextBox"
              className="flex-grow leading-normal pt-2 px-3 resize-none text-x outline-none h-12"
              placeholder="Type something here"
              onChange={(e) => setMessageText(e.target.value)}
              value={messageText}
              onKeyPress={handleKeyPress}
            />
            <div className="flex">
              <SendIcon onClick={handleMessage} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TreatmentMessages;